<template>
  <div class="geofences">
    <geofence-filters></geofence-filters>
    <div class="geofence-list">
      <div v-for="(geofence, index) in geofences" :class="{'geofence':true, 'show':geofence.showForm}" :key="'GEO_' + geofence.id">
        <div class="geofence-title isDesktop" @click="toggleForm(index, geofence.id)">
          <span class="color" v-bind:style="geofence.overlayColor ? { backgroundColor: '#' + geofence.overlayColor } : { backgroundColor: '#' + geofence.color }"></span>
          <span class="name">{{ geofence.name }}</span>
          <i class="fa fa-caret-down" v-show="!geofence.showForm"></i>
          <i class="fa fa-caret-up" v-show="geofence.showForm"></i>
          <span class="geofence-type">{{ formatGeofenceType(geofence.type) }}</span>
          <label class="show-map" @click.stop>
            <input type="checkbox" :value="geofence.id" v-model="polygons" />
            <span>SHOW ON MAP</span>
          </label>
        </div>

        <div class="geofence-title isMobile" @click="toggleForm(index, geofence.id)">
          <div>
            <span class="geofence-type">{{ formatGeofenceType(geofence.type) }}</span>
            <label class="show-map" @click.stop>
              <input type="checkbox" :value="geofence.id" v-model="polygons" />
              <span>SHOW ON MAP</span>
            </label>
          </div>
          <div>
            <div>
              <span class="color" v-bind:style="geofence.overlayColor ? { backgroundColor: '#' + geofence.overlayColor } : { backgroundColor: '#' + geofence.color }"></span>
              <span class="name">{{ geofence.name }}</span>
            </div>

            <div @click="">
              <i class="fa fa-plus-circle" v-show="!geofence.showForm"></i>
              <i class="fa fa-minus-circle" v-show="geofence.showForm"></i>
            </div>
          </div>
        
        </div>

        <div v-bind:class="{ 'geofence-form': true, show: geofence.showForm }">
          <geofence-fields :geofence="geofence" :key="geofence.id" :ref="'geofenceField' + index"
            :loadOtherData="loadOtherData[index] || false"></geofence-fields>
        </div>
      </div>
      <div class="empty-list" v-show="geofences.length <= 0">
        <i class="far fa-compass fa-lg"></i>
        <div class="message">No Geofences found.</div>
      </div>
    </div>

    <div v-bind:class="{ 'geofence-loading': true, show: isLoading }">
      <div class="loading-content">
        <div class="loading">
          <i class="fa fa-spinner fa-spin fa-lg"></i>
          <div class="message">LOADING...</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import GeofenceFields from './GeofenceFields'
import GeofenceFilters from './GeofenceFilters'

export default {
  name: 'geofence-list',
  components: { GeofenceFields, GeofenceFilters },
  data () {
    return {
      loadOtherData: []
    }
  },
  computed: {
    geofences () { return this.$store.state.geofences.geofences.items },
    isLoading () { return this.$store.state.geofences.geofences.loading },
    polygons: {
      get () {
        let result = []
        let polygons = this.$store.state.geofences.map.polygons

        for (let i = 0; i < polygons.length; i++) {
          result.push(polygons[i].id)
        }

        return result
      },
      set (values) {
        let self = this

        let result = []
        for (let i = 0; i < self.geofences.length; i++) {
          let geofence = self.geofences[i]

          for (let j = 0; j < values.length; j++) {
            let value = values[j]
            if (geofence.id !== value) {
              continue
            }

            let color = geofence.overlayColor || geofence.color
            result.push({
              id: geofence.id,
              points: geofence.polygon,
              color: '#' + color.toUpperCase()
            })

          }
        }
        self.$store.commit('geofences/setPolygon', result)
      }
    },
    filterType () { return this.$store.state.geofences.filters.type }
  },
  methods: {
    formatGeofenceType (type) {
      if (type === 'servicearea') {
        return 'SERVICE AREA GEOFENCE'
      }
      return type.toUpperCase() + ' GEOFENCE'
    },
    toggleForm (index, id) {
      let self = this
      self.geofences[index].showForm = !self.geofences[index].showForm

      if (self.geofences[index].showForm) {
        if (self.$refs['geofenceField' + index][0].getInfo()) {
          self.$refs['geofenceField' + index][0].getInfo()
        }
      }

      if (self.filterType === 'airport') {
        self.loadOtherData[index] = self.geofences[index].showForm
      }
    }
  },
  watch: {
    geofences: function (value) { this.loadOtherData = [] }
  }
}
</script>

<style lang="scss" scoped>
.geofences {
  padding: 20px;
  display: block;
  position: relative;
  margin-bottom: 40px;
}

.geofence {
  border-radius: 3px;
  margin-bottom: 15px;
  overflow: hidden;
  border: 1px solid rgba(0,0,0,0.15);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);

  &.show{ overflow: visible; }
  & .geofence-title {
    position: relative;
    display: block;
    padding: 10px 15px 12px;
    background-color: #fff;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;

    &.isMobile {
      display: none;
    }

    & > span, & > i {
      display: inline-block;
      vertical-align: middle;
    }

    & .color {
      width: 13px;
      height: 13px;
      border: 1px solid rgba(0,0,0,0.2);
      border-radius: 3px;
      margin-right: 10px;
    }

    & i {
      color: #999;
      position: absolute;
      right: 0;
      top: 0;
      padding: 15px;
      cursor: pointer;
      color: #0D79F2;
    }

    & .geofence-type {
      position: absolute;
      top: 0;
      right: 160px;
      padding: 14px 10px;
      font-size: 12px;
      color: #555;
    }

    & .show-map {
      font-size: 12px;
      color: #0D79F2;
      position: absolute;
      top: 0;
      right: 30px;
      padding: 13px 10px;
      & > * {
        display: inline-block;
        vertical-align: middle;
        margin: 0;
        width: auto;
      }

      & input { margin-right: 3px; }
    }
  }

  &:last-child {
    margin-bottom: 50px;
  }
}

.geofence-form {
  overflow: hidden;
  // padding: 0 15px;
  transition: all 250ms;
  background-color: #fff;
  height: 0;
  border-top: 1px solid rgba(0,0,0,0.15);
  opacity: 0;

  &.show {
    height: auto;
    // padding: 15px;
    opacity: 1;
    overflow: visible;
  }
}

.geofence-list {
  margin-top: 90px;
}

.empty-list {
  text-align: center;
  color: #777;
  padding: 30px 0;

  & .message {
    margin-top: 5px;
    font-weight: 700;
  }
}
.geofence-loading {
  position: absolute;
  overflow: hidden;
  top: -150%;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  transition: all 250ms;
  z-index: 5;

  &.show {
    top: 0;
    opacity: 1;
  }

  & .loading-content {
    margin-top: 20px;
  }

  & .loading {
    background-color: #fff;
    width: 170px;
    margin: 0 auto;
    border-radius: 3px;
    text-align: center;
    padding: 15px;
    color: #777;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);

    & .message {
      font-weight: 700;
      color: #555;
      margin-top: 5px;
    }
  }
}

@media only screen and (max-width: 430px) {  
  .geofences {
    padding: 12px 2rem 80px;
  }

  .geofence-loading.show {
    height: 100vh;
  }
  .geofence-list {
    margin-top: 65px;

    .geofence {
      border-radius: 5px;
        .geofence-title {
          &.isDesktop {
            display: none;
          }

          &.isMobile {
            display: flex;
          }

          flex-direction: column;
          padding: 10px;

          div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            span, label, i {
              position: unset;
              padding: 0;
              &.geofence-type {
                color: #aaa;
                font-size: 10px;
              }

              &.fa {
                font-size: 16px;
                display: flex;
                align-items: center;
                margin: 6px 0 2px;

              }
            }
          }

          .color {
            margin-right: 6px;
          }

          .show-map {
            font-size: 11px;
          }
        }
      
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/GeofenceList.vue